import React from "react";
import { EnrichedSwarovskiProductFrontendProductReview, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { PDPReviewsDetailsReviewsListElement } from "./PDPReviewsDetailsReviewsListElement";
import { ReviewTranslations } from "./reviewTranslations";

export const PDPReviewsDetailsReviewsList: React.FC<{
  reviews: Array<EnrichedSwarovskiProductFrontendProductReview>;
  t: ReviewTranslations;
  reviewDateFormatter: (createdDateIsoString: string) => string;
}> = ({ reviews, t, reviewDateFormatter }) => {
  return (
    <ul className="u-flex u-flex-col u-gap-5">
      {reviews.map(review => (
        <PDPReviewsDetailsReviewsListElement
          key={review.id}
          review={review}
          reviewDateFormatter={reviewDateFormatter}
          t={t}
        />
      ))}
    </ul>
  );
};
